'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
        $('.product-description-long').hide();
        ReadmoreDescription();
    });
    
    updateDom($results, '.refinements');
   
    expandRefinedSection();
    
    ReadmoreDescription(); 
   
}

function expandRefinedSection() {
     var $selected = $('.refinement').find('button span.selected');
     $selected.parents('.expand-level').each(function () {
            $(this).closest('.first-level').toggleClass('active');
            $(this).closest('.first-level.active').find('.second-level').slideToggle('fast');
            $(this).closest('.second-level').toggleClass('active');
            $(this).closest('.second-level.active').find('.third-level').slideToggle('fast');
            $('.product-description-long').hide();
            ReadmoreDescription();
    });
     	
}

function ReadmoreDescription() {
	$(".show_hide").off().on("click", function (e) {
		e.preventDefault();
        var txt = $(".product-description-long").is(':visible') ? 'Read more' : 'Read less';
        $(".show_hide").text(txt);
        $(this).parent().find('.product-description-long').toggle();
    });
}
/**
* Refinement toggle events
*/
 function filterRefinement() {
 
    	$('.first-head').click (function(e) {
			e.preventDefault();
  			var $this = $(this);
  			$(this).closest('.first-level').toggleClass('active');
			$this.closest('.first-level').find('.second-level').slideToggle();
		});
		
		$('.second-head').click (function(e) {
			 e.preventDefault();
			 var $this = $(this);
			 $(this).closest('.second-level').toggleClass('active');
			 $this.closest('.second-level').find('.third-level').slideToggle();
		});
			 		
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        '.refinement': filterRefinement
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function plpTooltip() {
    $('.info-icon').on('mouseenter focusin', function () {
        $(this).find('.tooltip').removeClass('d-none');
    });

    $('.info-icon').on('mouseleave focusout', function () {
        $(this).find('.tooltip').addClass('d-none');
    });
};

module.exports = {
	filterRefinement : filterRefinement,
	expandRefinedSection : expandRefinedSection,
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $('.product-description-long').hide();
                    ReadmoreDescription();
                    
                    $.spinner().stop();
                    plpTooltip();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                    plpTooltip();
                    //code for elleipses for plp page tile description
                    setTimeout(function () { $('.five-lines').ellipsis({ lines: 5 }); }, 100);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        plpTooltip();
                        if ($('.product-description-long').parents('.no-result-category').length > 0) {
                            if($('.container').hasClass('results-avilable')) {
                                $('.container').removeClass('results-avilable')
                            }
                        } else {
                            if(!$('.container').hasClass('results-avilable')) {
                                $('.container').addClass('results-avilable')
                            }
                        }
                        $('.product-description-long').hide();
                        ReadmoreDescription();
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },
	 ReadMore : function () {
    	if($('.refinement-content-type.active').length > 0) {
    		$(document).on('click','.show-more-refinement', function (e) {
    			e.preventDefault();
    			$('.item.hide').removeClass('hide');
    			$(this).hide();
    			$('.show-less').show();
    		});
    		$(document).on('click','.show-less' , function (e) {
    			e.preventDefault();
    			$('.item.extra').addClass('hide');
    			$(this).hide();
    			$('.show-more-refinement').show();
    		});
        }
    	
    },
    
    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    }
    
};
